<template>
  <div class="slider-container">
    <div class="slider-wrapper">
      <!-- Track -->
      <div class="slider-track"></div>

      <!-- Min Handle -->
      <div class="slider-handle" :style="{ left: `${(minValue / maxRange) * 100}%` }"
        @mousedown="startDragging('min', $event)"></div>

      <!-- Max Handle -->
      <div class="slider-handle" :style="{ left: `${(maxValue / maxRange) * 100}%` }"
        @mousedown="startDragging('max', $event)"></div>

      <!-- Range Between Handles -->
      <div class="slider-range" :style="{
        left: `${(minValue / maxRange) * 100}%`,
        width: `${((maxValue - minValue) / maxRange) * 100}%`
      }" @mousedown="startDragging('range', $event)"></div>
    </div>

    <!-- Display Values -->
    <div class="values">
      <span>Min: {{ minValue }}</span>
      <span>Max: {{ maxValue }}</span>
    </div>
  </div>
</template>


<script>

export default {
  props: {
    maxRange: {
      type: Number,
      default: 900,
    },
    minInitial: {
      type: Number,
      default: 100,
    },
    maxInitial: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 50, // Step size for increment
    },
    value: {
      // v-model prop
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      minValue: this.value[0] || this.minInitial,
      maxValue: this.value[1] || this.maxInitial,
      dragging: null,
      rangeOffset: 0, // Offset for dragging the range
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        // When parent value changes, update internal values
        if (newValue && Array.isArray(newValue)) {
          this.minValue = newValue[0];
          this.maxValue = newValue[1];
        }
      },
    },

  },
  methods: {
    emitValues() {
      this.$emit("input", this.minValue +"-"+  this.maxValue);
    },
    startDragging(type, event) {
      event.preventDefault();
      this.dragging = type;

      if (type === "range") {
        this.rangeOffset = event.clientX; // Use event.clientX here
      }

      document.addEventListener("mousemove", this.handleDragging);
      document.addEventListener("mouseup", this.stopDragging);
    },
    handleDragging(event) {
      if (!this.dragging) return; // Exit if dragging isn't active

      const slider = this.$el.querySelector(".slider-wrapper");
      const sliderRect = slider.getBoundingClientRect();
      const sliderWidth = sliderRect.width;
      const offsetX = event.clientX - sliderRect.left;

      // Calculate and handle drag logic
      if (this.dragging === "range") {
        const deltaX = event.clientX - this.rangeOffset;
        const rangeWidth = this.maxValue - this.minValue;
        const deltaValue = Math.round(
          (deltaX / sliderWidth) * this.maxRange / this.step
        ) * this.step;

        if (
          this.minValue + deltaValue >= 0 &&
          this.maxValue + deltaValue <= this.maxRange
        ) {
          this.minValue += deltaValue;
          this.maxValue += deltaValue;
          this.rangeOffset = event.clientX; // Update range offset
        }
      } else {
        let newValue = Math.round((offsetX / sliderWidth) * this.maxRange);
        newValue = Math.round(newValue / this.step) * this.step;

        if (this.dragging === "min") {
          this.minValue = Math.min(
            Math.max(0, newValue), // Ensure value is >= 0
            this.maxValue - this.step // Prevent overlap with max handle
          );
        } else if (this.dragging === "max") {
          this.maxValue = Math.max(
            Math.min(this.maxRange, newValue), // Ensure value is <= maxRange
            this.minValue + this.step // Prevent overlap with min handle
          );
        }
      }
    },
    stopDragging() {
      this.dragging = null;
      this.emitValues();
      document.removeEventListener("mousemove", this.handleDragging);
      document.removeEventListener("mouseup", this.stopDragging);
    },
  },
};
</script>

<style scoped>
.slider-container {
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.slider-wrapper {
  position: relative;
  width: 100%;
  height: 15px; /* Increased height for easier interaction */
  background-color: #ddd;
  margin: 20px 0;
  border-radius: 7px; /* Increased border-radius */
}

.slider-track {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #ddd;
  border-radius: 7px;
}

.slider-range {
  position: absolute;
  height: 100%;
  background-color: #007bff;
  /* Blue color for the range */
  border-radius: 7px;
  cursor: grab; /* Visual feedback for dragging */
}

.slider-handle {
  position: absolute;
  top: -5px; /* Adjusted for better visibility */
  width: 25px; /* Increased size for easier interaction */
  height: 25px; /* Increased size for easier interaction */
  background-color: #007bff;
  /* Blue color for handles */
  border-radius: 50%;
  cursor: pointer;
  border: 3px solid #fff; /* Increased border size */
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  transform: translateX(-50%);
}

.values {
  display: flex;
  justify-content: space-between;
}
</style>
